<template>
  <div class="index" @click="h5show = false">
    <!-- <div class="imgcenter">
      <img src="../../static/bg4.jpg" />
    </div> -->
    <div class="index-con">
      <div class="big-title">
        <span>Contact us</span>
      </div>
      <div style="max-width: 420px; margin: 0 auto; line-height: 2.4; font-size: 15px; color: #333; padding: 0 20px;">
        <div style="display: flex; align-items: center;"><i class="el-icon-user-solid"
            style="color: #0a9a7a; font-size: 20px; margin-right: 12px; width: 24px; text-align: center;"></i><b
            style="color: #0a9a7a; min-width: 72px;">Contact:</b><span>Aihong Tan</span></div>
        <div style="display: flex; align-items: center;"><i class="el-icon-phone"
            style="color: #0a9a7a; font-size: 20px; margin-right: 12px; width: 24px; text-align: center;"></i><b
            style="color: #0a9a7a; min-width: 72px;">Tel:</b><span>18958140876</span></div>
        <div style="display: flex; align-items: center;"><i class="el-icon-message-solid"
            style="color: #0a9a7a; font-size: 20px; margin-right: 12px; width: 24px; text-align: center;"></i><b
            style="color: #0a9a7a; min-width: 72px;">Email:</b><span>tanah@cjlu.edu.cn</span></div>
      </div>
      <div class="bottom_span"></div>

      <p style="text-align: center; margin:10px 0">
        baidu map
      </p>
      <iframe src="https://j.map.baidu.com/69/knKM" width="100%" height="550" style="border: 0" allowfullscreen=""
        loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>

      <p style="text-align: center; margin:10px 0">
        google map
      </p>
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d101986.2302357285!2d120.32391951985419!3d30.314583356741167!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x344c9795aa551bb3%3A0x179ee0e8ad3a7d13!2z5Lit5Zu96K6h6YeP5aSn5a2m!5e0!3m2!1szh-CN!2sus!4v1776217271049!5m2!1szh-CN!2sus"
        width="100%" height="550" style="border: 0" allowfullscreen="" loading="lazy"
        referrerpolicy="no-referrer-when-downgrade"></iframe>

      <div class="bottom_span"></div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      h5show: false,
    };
  },
  methods: {},
};
</script>

<style scoped>
.bottom_span {
  padding-top: 80px;
}

.small-title {
  font-size: 17px;
  font-weight: 600;
  margin-bottom: 20px;
}

.index-con {
  margin: 0 auto;
  width: 1200px;
}

.navbg {
  width: 100%;
  height: 50px;
  display: flex;
  justify-content: center;
}

.text {
  color: #333;
  text-indent: 2em;
  line-height: 2;
  padding-bottom: 20px;
}

@media screen and (max-width: 768px) {
  .index-con {
    width: 100%;
  }

  .nav {
    width: 100%;
  }

  .navbg {
    display: none;
  }

  .title {
    font-size: 18px;
  }

  .index {
    padding: 40px 10px 0;
    box-sizing: border-box;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/contact.vue